import React from 'react';

import cn from 'classnames';
import { noop } from 'lodash';
import { string, func, element } from 'prop-types';
import { Link } from 'react-router-dom';

import Tooltip from '@mui/material/Tooltip';

import s from './ShadowLink.css';

const ShadowLink = ({ tooltipTitle, url, icon, linkClass, onClick }) => (
  <Tooltip arrow title={tooltipTitle}>
    <Link className={s.shadowLinkWrapper} to={url} href={url} onClick={onClick}>
      <div className={cn(s.shadowLink, linkClass)}>{icon}</div>
    </Link>
  </Tooltip>
);

ShadowLink.propTypes = {
  url: string,
  onClick: func,
  icon: element.isRequired,
  linkClass: string.isRequired,
  tooltipTitle: string.isRequired,
};

ShadowLink.defaultProps = {
  url: '',
  onClick: noop,
};

export default ShadowLink;
